export default __webpack_public_path__ + "static/media/ft-brand-01.149eab1b.png";